export default "__VITE_ASSET__COTMl$bF__"